// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.smses-component .smses-component-footer {
  width: 100%;
  height: 50px;
}
.smses-component .ant-radio div,
.smses-component .ant-checkbox div {
  all: unset;
}
.smses-component .ant-form-item-row {
  width: 100%;
}
.twilio-account-edit-component-assign-agent-wrapper-list {
  max-height: 500px;
  overflow: auto;
}
.sms-migrate-wrapper .my-number-mark {
  padding-left: 15px;
}
.sms-migrate-wrapper .my-number-mark Mark {
  padding: 0 10px;
  border-radius: 10px;
}
.account-modal-settings .modal-form-control-buttons {
  text-align: right;
  padding-top: 10px;
}
.ring-central-account-form .login-redirect {
  margin: 0 auto;
  display: block;
}
.create-new-chat-select-phone {
  width: 100%;
}
.custom-scrollbar::-webkit-scrollbar {
  width: 12px !important;
}
.custom-scrollbar::-webkit-scrollbar-track {
  border-radius: 8px !important;
  background-color: #e7e7e7 !important;
  border: 1px solid #cacaca !important;
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3) !important;
}
.custom-scrollbar::-webkit-scrollbar-thumb {
  border-radius: 8px !important;
  background-color: #363636 !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/smses/styles.less"],"names":[],"mappings":"AAAA;EAEI,WAAA;EACA,YAAA;AAAJ;AAHA;;EASM,UAAA;AAFN;AAPA;EAcI,WAAA;AAJJ;AAQA;EACE,iBAAA;EACA,cAAA;AANF;AASA;EAEI,kBAAA;AARJ;AAMA;EAKM,eAAA;EACA,mBAAA;AARN;AAaA;EAEI,iBAAA;EACA,iBAAA;AAZJ;AAgBA;EAEI,cAAA;EACA,cAAA;AAfJ;AAmBA;EACE,WAAA;AAjBF;AAoBA;EACE,sBAAA;AAlBF;AAqBA;EACE,6BAAA;EACA,oCAAA;EACA,oCAAA;EACA,uDAAA;AAnBF;AAsBA;EACE,6BAAA;EACA,oCAAA;AApBF","sourcesContent":[".smses-component {\n  .smses-component-footer {\n    width: 100%;\n    height: 50px;\n  }\n\n  .ant-radio,\n  .ant-checkbox {\n    div {\n      all: unset;\n    }\n  }\n\n  .ant-form-item-row {\n    width: 100%;\n  }\n}\n\n.twilio-account-edit-component-assign-agent-wrapper-list {\n  max-height: 500px;\n  overflow: auto;\n}\n\n.sms-migrate-wrapper {\n  .my-number-mark {\n    padding-left: 15px;\n\n    Mark {\n      padding: 0 10px;\n      border-radius: 10px;\n    }\n  }\n}\n\n.account-modal-settings {\n  .modal-form-control-buttons {\n    text-align: right;\n    padding-top: 10px;\n  }\n}\n\n.ring-central-account-form {\n  .login-redirect {\n    margin: 0 auto;\n    display: block;\n  }\n}\n\n.create-new-chat-select-phone {\n  width: 100%;\n}\n\n.custom-scrollbar::-webkit-scrollbar {\n  width: 12px !important;\n}\n\n.custom-scrollbar::-webkit-scrollbar-track {\n  border-radius: 8px !important;\n  background-color: #e7e7e7 !important;\n  border: 1px solid #cacaca !important;\n  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3) !important;\n}\n\n.custom-scrollbar::-webkit-scrollbar-thumb {\n  border-radius: 8px !important;\n  background-color: #363636 !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
